module.exports = __webpack_public_path__ + "img/add.ee8f7198.svg";